import { render } from "./DeviceTypeView.vue?vue&type=template&id=aee8ffe4"
import script from "./DeviceTypeView.vue?vue&type=script&lang=js"
export * from "./DeviceTypeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__